module.exports = __webpack_public_path__ + "media/images/icons/icons_small/69_twoCandles-6788300455346dbe5d065217942d201b.png";